(function () {
  'use strict';

  function DistributionCtrl (distributionFactory, Common, tmhDynamicLocale, moment, $scope, whereToFactory,
    $timeout) {
    const vm = this;
    let calculatePriceTimeOut;

    function updateClasses () {
      vm.dateClasses = distributionFactory.getCalendarDates();
    }

    function setDisabled (date, mode) {
      const weekends = date.date.getDay() === 0 || date.date.getDay() === 6;

      const dateFormatted = moment(date.date).format('MM-DD-YYYY');

      function filterHoliday (item) {
        return moment(item.date).format('MM-DD-YYYY') === dateFormatted;
      }

      const holiday = vm.holidays.filter(filterHoliday).length;

      return weekends || holiday;
    }

    function getClass (date) {
      const dayToCheck = new Date(date.date).setHours(0, 0, 0, 0);
      let dateClass;

      (vm.dateClasses || []).forEach(function (item, index) {
        const thisDate = new Date(item.date).setHours(0, 0, 0, 0);

        if (dayToCheck === thisDate) {
          dateClass = item.class;
        }

      });

      if (dateClass) {
        return dateClass;
      }
    }

    function refreshView (show) {
      updateClasses();
      $scope.$broadcast('datepickerRefreshView');
    }

    function plotOptionsInDatePicker () {
      if (Common.get('serviceType') === 'information') {
        distributionFactory.plotOptionDays(vm.options || []);
      }

      refreshView();
    }

    function updateProductsForYear (newDate) {
      const currentYear = moment().year();
      const newYear = moment(newDate).year();
      const oldYear = moment(distributionFactory.selectedDate).year();

      if (currentYear === newYear && oldYear === newYear) {
        return false;
      }

      Common.notifyObserver('web2print.products', { deliveryDate: moment(newDate).toISOString(), callback: buildSetDateCallback(newDate) });
      return true;
    }

    function buildSetDateCallback (newDate) {
      return () => {
        setDate(newDate, false, true);
      };
    }

    function setDate (changedModel, datePickerInit, skipUpdateProductsForYear) {
      if (!skipUpdateProductsForYear && !datePickerInit) {
        if (updateProductsForYear(changedModel)) {
          return;
        }
      }
      vm.selectedDeliveryType = null;
      vm.dateModel = changedModel;

      distributionFactory.selectedDate = changedModel;
      distributionFactory.setCurrentDate();

      if (!datePickerInit) {
        vm.options = distributionFactory.getDeliveryOptions(true);
        plotOptionsInDatePicker();
        vm.selectedId = null;
      }

      if (!vm.selectedId) {
        distributionFactory.deliveryDay = null;
        vm.selectedId = distributionFactory.setSelectedOption(vm.options);
      }

      changeSelectedDelivery();
    }

    function getDate () {
      const dateData = distributionFactory.selectedDate;

      return (dateData._d || dateData).getDate();
    }

    function getMonth () {
      const dateData = distributionFactory.selectedDate;

      return moment(dateData).format('MMM');

    }

    function zonePriceEqual (option) { //if prices for abroad are all equal, display them as one price
      if (!Common.checkZoneCount()) {
        return false;
      }

      let price = -1;
      for (let index = 1; index < option.postageProducts.length; index++) {
        const element = option.postageProducts[index];
        if (price === -1) {
          price = element.price_model.per_piece;
        } else if (price !== element.price_model.per_piece) {
          return false;
        }
      }

      return true;
    }

    function changeDeliveryDay (day, id) {
      if (day.time && distributionFactory.checkTime(day)) {
        return;
      }

      vm.selectedId = id;
      distributionFactory.deliveryDay = day;

      if (day.range && !day.invalidOption) {
        // 1st param: range of delivery days
        // 2nd param: delivery id
        // 3rd param: callback, refreshing datepicker
        distributionFactory.setCurrentDate(day.range, id, refreshView);
      } else if (!day.range && Common.get('serviceType') === 'DKLetters') {
        distributionFactory.resetCalendarDates(vm.options);
        refreshView();
      }

      changeSelectedDelivery(true);
    }

    function filterOption (item) {
      return item.id === vm.selectedId;
    }

    function changeSelectedDelivery (fromChangeDeliveryDay) {

      const selectedOption = vm.options.filter(filterOption)[0];

      // No options available
      if (!selectedOption) {
        return;
      }

      vm.selectedDelivery = selectedOption;
      distributionFactory.selectedDelivery = vm.selectedDelivery;
      distributionFactory.deliveryDay = distributionFactory.deliveryDay || vm.selectedDelivery.deliveryDays[0];

      if (!fromChangeDeliveryDay) {
        changeDeliveryDay(distributionFactory.deliveryDay, vm.selectedId);
      }

      updateStorage();
    }

    function isAdmail () {
      return Common.get('serviceType', 'information').indexOf('admail-') > -1;
    }

    function displayBuyingAddresses () {
      const recipients = Common.get('recipients', {});
      return recipients.targetType !== 'FILE' && recipients.addressType !== 'FILE';
    }

    function displayLowestPrice (postageProduct) {
      const product = getSelectedProduct();

      if (!product || (postageProduct && !postageProduct.price_model.lowest_price)) {
        return false;
      }

      const weight = product.weight;
      let totalWeight = 0;
      totalWeight += Number(weight.paper || 0);
      totalWeight += Number(weight.envelope || 0);
      totalWeight /= 10;
      return totalWeight <= 10;
    }

    function getTranslationKey (key) {
      const translationStrings = {
        foreign: {
          SE: 'DELIVERY_OPTIONS_PAGE_FOREIGN_MESSAGE',
          DK: 'DELIVERY_OPTIONS_PAGE_FOREIGN_MESSAGE_DK',
        }
      };

      return translationStrings[key][pnTopbar.market || 'SE'];
    }

    function activate (res) {
      // models
      vm.holidays = ((res || {}).result || []);
      vm.selectedDelivery = (Common.get('productDelivery', {}).pricingInfo || {}).deliveryOptions || null;
      vm.deliveryDay = (vm.selectedDelivery || {}).deliveryDays || null;
      vm.selectedId = (vm.selectedDelivery || {}).id || null;
      vm.zoneCount = Common.get('recipients.zoneCount', undefined);

      distributionFactory.holidays = vm.holidays;
      const dates = distributionFactory.getStartSelectedDates();

      vm.showCalendar = dates.showCalendar;
      vm.options = distributionFactory.deliveryOptions;

      vm.dateModel = dates.selectedDate;
      vm.language = pnTopbar.language;

      distributionFactory.selectedDelivery = vm.selectedDelivery;
      distributionFactory.deliveryDay = vm.deliveryDay;

      tmhDynamicLocale.set(pnTopbar.language);

      const selectDate = angular.copy(dates.selectedDate);
      setDate(moment(selectDate), true, false);

      vm.datePickerOptions = {
        'showWeeks': false,
        'datePickerMode': 'day',
        'maxMode': 'day',
        'numberOfMonths': 2,
        'dateDisabled': setDisabled,
        'minDate': dates.startDate,
        'customClass': getClass,
        'startingDay': 1
      };

      vm.dateClasses = distributionFactory.getCalendarDates();

      // functions
      vm.setDisabled = setDisabled;
      vm.updateClasses = updateClasses;
      vm.dateMethod = setDate;
      vm.getDate = getDate;
      vm.getMonth = getMonth;
      vm.checkTime = distributionFactory.checkTime;
      vm.showZoneCount = Common.checkZoneCount();
      vm.marketSE = pnTopbar.market === 'SE';
      vm.marketDK = pnTopbar.market === 'DK';
      vm.zonePriceEqual = zonePriceEqual;
      vm.changeDeliveryDay = changeDeliveryDay;
      vm.changeSelectedDelivery = changeSelectedDelivery;
      vm.displayBuyingAddresses = displayBuyingAddresses;
      vm.displayLowestPrice = displayLowestPrice;
      vm.getSelectedProduct = getSelectedProduct;
      vm.getTranslationKey = getTranslationKey;
      vm.disableOption = disableOption;
      vm.hideZoneLockedOption = hideZoneLockedOption;

      $scope.$on('changeLanguage', function (events, language) {
        tmhDynamicLocale.set(language);
        vm.language = language;
      });

      $scope.$on('checkYear', function (ev, date) {

        const calendarDate = moment(date);
        const year = calendarDate.year();
        const month = calendarDate.month();

        if (!distributionFactory.years.filter(distributionFactory.filterYear.bind({
          'year': year
        })).length && month === 11) {
          const generateYear = year + 1;

          distributionFactory.addYear(generateYear);
          distributionFactory.getHolidays((pnTopbar.market || 'SE'), pnTopbar.language, generateYear)
            .then(function (res) {
              vm.holidays = res.result;
            }, function (err) {
              console.log(err);
            });
        }
      });

      Common.registerObserver('refreshView', refreshView);
      console.log('datepicker activated');
    }

    function updateStorage () {
      whereToFactory.storeSelection(
        getSelectedProduct(),
        distributionFactory.selectedDate,
        angular.copy(distributionFactory.selectedDelivery),
        Common.get('preface', false),
        distributionFactory.deliveryDay
      );

      $timeout.cancel(calculatePriceTimeOut);
      calculatePriceTimeOut = $timeout(() => {
        Common.notifyObserver('web2print.pricing');
      }, 500);
    }

    function getSelectedProduct () {
      return distributionFactory.selectedProduct;
    }

    function getHolidays () {
      // setting this function here so that it will show the spinner
      vm.isAdmail = isAdmail;
      Common.registerObserver('updateDatepickerClasses', updateClasses);
      distributionFactory.getHolidays((pnTopbar.market || 'SE'), pnTopbar.language, moment().year())
        .then(activate, function (err) {
          console.log(err);
        });
    }

    function disableOption (day) {
      return day.invalidOption || distributionFactory.checkTime(day);
    }

    function hideZoneLockedOption (option) {
      return option.zoneLocked && vm.showZoneCount;
    }

    getHolidays();
  }

  angular.module('web2print.whereTo')
    .controller('DistributionCtrl', DistributionCtrl);

  DistributionCtrl.$inject = ['distributionFactory', 'Common', 'tmhDynamicLocale', 'moment', '$scope', 'whereToFactory',
    '$timeout'];
})();
